import { formatCurrency } from '../functions.js';
const INTERVAL = 200;

function Klarna() {
    let enabled = false;
    let registration = null;
    let oldShippingOption = null;
    let registered = false;

    function poll() {
        if (window._klarnaCheckout) {
            window._klarnaCheckout(function (api) {
                api.on({
                    'load': function (data) {
                        updateYourOrder(data.shipping_option_change);
                    }
                });
                api.on({
                    'shipping_option_change': function (shippingOption) {
                        if (!enabled)
                            return;

                        try {
                            let priceDiff = shippingOption.price;

                            if (oldShippingOption)
                                priceDiff = shippingOption.price - oldShippingOption.price;

                            priceDiff /= 100.0;

                            for (const el of document.querySelectorAll('.order-total')) {
                                if (el.dataset.value) {
                                    let res = Number(el.dataset.value) + priceDiff;

                                    el.innerHTML = formatCurrency(res);
                                    el.dataset.value = res;
                                }
                            }

                            oldShippingOption = shippingOption;
                            updateYourOrder(shippingOption);
                        } catch (e) {
                            console.error(e);
                        }
                    },
                });
            });
            registered = true;
        } else {
            registration = setTimeout(poll, INTERVAL);
        }
    }

    function disable() {
        enabled = false;
        clearTimeout(registration);
    }

    function enable() {
        if (document.getElementById('klarna')) {
            enabled = true;
            if (!registered)
                registration = setTimeout(poll, INTERVAL);
        }
        return enabled;
    }

    function isEnabled() {
        return enabled;
    }

    function updateYourOrder(shippingOption) {
        showSelectedDeliveryTypeCost(shippingOption);

        let sumOfAllCostElements = countSum("totalCostElement");
        showTotal(formatCurrency(sumOfAllCostElements));
    }

    function showSelectedDeliveryTypeCost(shippingOption) {
        let deliveryTypeElement = document.getElementById("deliveryTypeElement");
        let selectedDeliveryTypePrice = shippingOption.price / 100;
        deliveryTypeElement.innerText = formatCurrency(selectedDeliveryTypePrice);
    }

    function showTotal(sumOfCountedElements) {
        let totalElement = document.getElementById("totalElement");
        totalElement.innerText = sumOfCountedElements;
    }

    function countSum(countedElementsClassName) {
        let elements = Array.from(document.getElementsByClassName(countedElementsClassName));
        let sum = elements.reduce((acc, element) => acc + parseInt(element.innerText), 0);

        return sum;
    }

    disable = disable.bind(this);
    this.disable = disable;
    enable = enable.bind(this);
    this.enable = enable;
    isEnabled = isEnabled.bind(this);
    this.isEnabled = isEnabled;
    return this;
};

export default Klarna;